<template>
  <div>
    <app-notification :title="'יש לנו כמה שאלות...'"
                      :text="'כדי להכין לך תזרים מדויק, נצטרך תשובות לכמה שאלות. זה יקח רק דקה.'"
                      :notification-buttons="[
                        {
                          title:'לדיוק התזרים',
                          variant: 'primary',
                          action: openInvestigation,
                        },
                      ]"
                      :icon-type="'warning'"/>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';
import ModalBus from '../../../../../../../event-bus/modal-bus';
import MergeInvestigation from '../../investigations/merge-investigation-in-app/MergeInvestigation.vue';

export default {
  name: 'MergeQuestionsNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('AccountQuestionsNotificationShown');
  },
  computed: {
    ...mapGetters('applicationState', ['barTypes', 'notificationTypes']),
  },
  methods: {
    ...mapMutations('applicationState', ['setBarState', 'setNotificationState']),
    openInvestigation() {
      ModalBus.$emit('open', {
        component: MergeInvestigation,
        props: {
          onDoneInvestigation: this.onDoneInvestigation,
        },
      });
    },
    onDoneInvestigation() {
      this.setNotificationState(this.notificationTypes.PROCESSING_CASHFLOW);
      this.setBarState(this.barTypes.PROCESSING);
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
